import { call, put, takeLatest } from "redux-saga/effects";
import { GET_TaskList, GET_TaskDetail, POST_Task, PUT_Task, DELETE_Task, GET_TaskComments, POST_TaskComment, DELETE_TaskComment } from "../services/Task";
import exception from "../utils/exception";
import { jwtDecode, jwtEncode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_TaskListEffect({ payload, projectId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    const res = yield call(GET_TaskList, token, projectId, query);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_TaskList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_TaskDetailEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    const res = yield call(GET_TaskDetail, token, query);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_TaskDetail", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_TaskEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_Task, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_TaskEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(PUT_Task, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_TaskEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    yield call(DELETE_Task, token, query);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_TaskCommentsEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    const res = yield call(GET_TaskComments, token, query);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_TaskComments", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_TaskCommentEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const formData = new FormData();
    const data = yield call(jwtEncode, payload);
    formData.append("data", data);
    yield call(POST_TaskComment, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* DELETE_TaskCommentEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const data = yield call(jwtEncode, payload);
    const query = { Data: data };
    yield call(DELETE_TaskComment, token, query);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_TaskList", GET_TaskListEffect);
  yield takeLatest("GET_TaskDetail", GET_TaskDetailEffect);
  yield takeLatest("POST_Task", POST_TaskEffect);
  yield takeLatest("PUT_Task", PUT_TaskEffect);
  yield takeLatest("DELETE_Task", DELETE_TaskEffect);
  yield takeLatest("GET_TaskComments", GET_TaskCommentsEffect);
  yield takeLatest("POST_TaskComment", POST_TaskCommentEffect);
  yield takeLatest("DELETE_TaskComment", DELETE_TaskCommentEffect);
}
